module.exports = __webpack_public_path__ + "static/media/national-van-lines.58961153.png";